const prod = process.env.NODE_ENV === 'production'
const protocol = document.location.protocol == 'https:'



module.exports = {
  'SERVER_URL': prod ? protocol ? 'https://user_api.nerv.idailymedia.com' : 'http://miso_api.ramen.idailymedia.com' :'http://127.0.0.1:4031',
  'CLIENT_URL': prod ? protocol ? 'https://user.nerv.idailymedia.com' : 'http://miso.ramen.idailymedia.com' :'http://127.0.0.1:4032',
}